import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconFilter}
 */
const IconFilter = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            viewBox='0 0 20 20'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M11.416 7.08268V6.41602H13.666V3.41602H14.3327V6.41602H16.5827V7.08268H11.416ZM13.666 16.5827V9.41602H14.3327V16.5827H13.666ZM5.66602 16.5827V13.5827H3.41602V12.916H8.58268V13.5827H6.33268V16.5827H5.66602ZM5.66602 10.5827V3.41602H6.33268V10.5827H5.66602Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconFilter;
